import type { ContentBranch } from '../types';

/**
 * Returns true if the branch can be mutated. False otherwise (merged, etc).
 */
export function isBranchWritable(branch: ContentBranch): boolean {
    return !branch.revisionMerged;
}
